const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        tabConfigNavKey: 'projects',
    },

    methods: {
        sanitizeTabOptionsByAttributes(tabOptions, entityAttributes, entityID){
            const titleParts = []
            if(entityAttributes.startTS)    titleParts.push(`${utils.moment(entityAttributes.startTS).format('DD.MM.YYYY')} -`);
            if(entityAttributes.title)      titleParts.push(entityAttributes.title);
            tabOptions.title = titleParts.join(' ')
            // tabOptions.titleSuffix = ` [${entityID}]`

            return tabOptions
        },
    },

    // hooks: {
    //     attach: function($element, options){
    //         if(!options.refresh){
    //             setTimeout(() => {
    //                 this.find('templates_office_projectTerms_table', table => {
    //                     let nrOfElements = 0
    //                     const elements = table.$.find('tbody > tr')
    //                     for(const e in elements){
    //                         if(typeof elements[e].click === 'function'){
    //                             elements[e].click()
    //                             nrOfElements++;
    //                             if(nrOfElements >= 1){
    //                                 break
    //                             }
    //                         }
    //                     }
    //                 })
    //             }, 50)
    //         }
    //     }
    // }
}